import apiService from '../apiService';

/**
 * Staff side of the client portal (OL-194): sharing matter files and folders
 * with guests, and managing those guests. Every call needs the
 * share-matter-files permission.
 *
 * Ids here are uuids; the server sends them as `id` already.
 */
const matterSharingService = {
  async getShares(matterId) {
    const response = await apiService.get(`/matters/${matterId}/shares`);
    return response.data.data ?? [];
  },

  /**
   * Contacts this user may share with (OL-198: guests are contacts), the
   * matter's own contact first. Each row: {id, name, email, type,
   * is_matter_contact, guest_status}.
   */
  async searchContacts(matterId, search = '') {
    const response = await apiService.get(`/matters/${matterId}/shares/contacts`, { params: { search } });
    return response.data.data ?? [];
  },

  /**
   * @param payload {case_file_ids, contact_id | new_contact {first_name,
   *                 last_name, email, contact_type_id}, access_level,
   *                 expires_at, notify, message}
   */
  async share(matterId, payload) {
    const response = await apiService.post(`/matters/${matterId}/shares`, payload);
    return response.data.data;
  },

  async updateShare(shareId, payload) {
    const response = await apiService.patch(`/matter-shares/${shareId}`, payload);
    return response.data.data;
  },

  async revokeShare(shareId) {
    const response = await apiService.post(`/matter-shares/${shareId}/revoke`);
    return response.data.data;
  },

  /** Guest activity on the matter, newest first (OL-196). */
  async getMatterAccessLog(matterId) {
    const response = await apiService.get(`/matters/${matterId}/shares/access-log`);
    return response.data.data ?? [];
  },

  /** One guest's activity; matters this user can't open are left out. */
  async getGuestAccessLog(guestId) {
    const response = await apiService.get(`/portal-guests/${guestId}/access-log`);
    return response.data.data ?? [];
  },

  async getGuests() {
    const response = await apiService.get('/portal-guests');
    return response.data.data ?? [];
  },

  async resendInvite(guestId, message = null) {
    const response = await apiService.post(`/portal-guests/${guestId}/resend-invite`, { message });
    return response.data;
  },

  async disableGuest(guestId) {
    const response = await apiService.post(`/portal-guests/${guestId}/disable`);
    return response.data.data;
  },

  async enableGuest(guestId) {
    const response = await apiService.post(`/portal-guests/${guestId}/enable`);
    return response.data.data;
  },
};

export default matterSharingService;
